























import {Vue, Component, Prop} from 'vue-property-decorator'
import NotificationIcon from '../../../../assets/svg/notification.svg';
import {Notification as NotificationModel} from "@api/models/notifications/Notification";
import {process} from '@common/MessageProcessor';
import { NotificationLinkHelper } from "../../helpers/NotificationLinkHelper"
import { Debounce } from 'vue-debounce-decorator';
import { getBackend } from '@service/router/getters';

@Component({
    components: { NotificationIcon }
})
export default class NotificationCampaing extends Vue {
    @Prop() notification: NotificationModel;

    get isRead(): boolean {
        return this.notification.isRead;
    }

    get currentLocale(): string {
        return this.$store.state.session?.language || navigator.language.split('-')[0] || "ru";
    }

    get text(): string {
        return process(this.notification.body);
    }

    get isNews(): boolean {
        return !!this.notification.deepLink && this.notification.deepLink.includes('NewsPageActor');
    }

    get title(): string {
        return this.isNews
            ? this.$t('notifications.viewingInApp').toString()
            : ""
    }

    @Debounce(400)
    async openLink() {
        if (this.isNews) {
            return false;
        }

        if (this.notification.deepLink) {
            const linkHelper = new NotificationLinkHelper(this.$store, this.$repositories);

            const params = {
                source: this.notification.deepLink!,
                backend: getBackend(this.$route.params.backend) as string,
                router: this.$router,
                route: this.$route
            };

            await linkHelper.openDeepLink(params);
        }
    }
}
